import request, { ResponsePageableData } from '@/libs/request/requestOta'

let baseURL = process.env.VUE_APP_OTA_BASE_URL

/** 设置模型字段 */
// 订单列表
export const getOrderList = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/xcpms/order', data, method: 'GET' })

// 失败订单列表
export const getOrderListFailed = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/xcpms/orderfailed', data, method: 'GET' })

// 重试失败订单
export const putOrderListFailed = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/xcpms/orderfailed', data, method: 'PUT' })

// 完成未处理订单
export const putOrderList = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/xcpms/order', data, method: 'PUT' })

// 取消成功订单
export const cancleOrderList = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/xcpms/order', data, method: 'PUT' })

// 酒店映射表列表
export const getHotelsList = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/xcpms/hotel', data, method: 'GET' })

// 酒店房型列表
export const getPmsroomlist = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/pms/room/', data, method: 'GET' })

// 新增酒店映射表
export const postXcpmsHotel = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/xcpms/hotel', data, method: 'POST' })

// 编辑酒店映射表
export const putXcpmsHotel = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/xcpms/hotel', data, method: 'PUT' })

// 删除酒店映射表
export const deleteXcpmsHotel = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/xcpms/hotel', data, method: 'DELETE' })

// 房型映射表
export const gethotelroomsList = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/xcpms/hotelroom', data, method: 'GET' })

// 新增房型映射表
export const postXcpmshotelroom = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/xcpms/hotelroom', data, method: 'POST' })

// 编辑房型映射表
export const putXcpmshotelroom = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/xcpms/hotelroom', data, method: 'PUT' })

// 删除房型映射表
export const deleteXcpmshotelroom = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/xcpms/hotelroom', data, method: 'DELETE' })

// 酒店有效房型列表
export const getRoomAvailList = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/pms/room-avail', data, method: 'GET' })

// 重下订单
export const putOrderListAgain = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/pms/order', data, method: 'PUT' })

// 新增订单
export const postOrderList = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/pms/order', data, method: 'POST' })

// 取消订单
export const deleteOrderList = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/pms/order', data, method: 'DELETE' })

// 获取财务信息列表
export const getFinancial = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/financial', data, method: 'GET' })

// 新增财务
export const postFinancial = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/financial', data, method: 'POST' })

// 编辑财务信息
export const putFinancial = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/financial', data, method: 'PUT' })

// 删除财务信息
export const deleteFinancial = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/financial', data, method: 'DELETE' })

// 对账单列表
export const getbill = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/bill', data, method: 'GET' })

// 导入渠道对账单
export const importbill = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/bill/import', data, method: 'GET' })

// 对账
export const getbillCompare = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/bill/compare', data, method: 'GET' })

// 同步渠道单到PMS单
export const postBillpms = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/bill-pms', data, method: 'POST' })

// 调整PMS账单
export const putBillpms = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/bill-pms', data, method: 'PUT' })

//删除PMS账单
export const deleteBillpms = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/bill-pms', data, method: 'DELETE' })

// 账单明细
export const getBillchannel = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/bill-channel', data, method: 'GET' })

// 发票上传
export const postInvoiceUpload = () => process.env.VUE_APP_OTA_BASE_URL + 'v1/invoice/upload'

// 发票下载
export const getInvoiceiew = () => process.env.VUE_APP_OTA_BASE_URL + 'v1/invoice/view'

export const getInvoiceiew2 = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/invoice/view', data, method: 'GET' })

// 平账
export const putBill = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/bill', data, method: 'PUT' })

// 未匹配账单列表
export const getMatch = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/bill-channel/match', data, method: 'GET' })

// 匹配账单
export const putMatch = (data?) => request<ResponsePageableData>({ baseURL, url: '/v1/bill-channel/match', data, method: 'PUT' })
